import React from 'react';
import { Button } from '@billda/design-system';
import { SiteAssignmentDto } from '../api/userSiteAssignmentsApi';
import { What3WordsLink } from '../../../shared/components/atoms/What3WordsLink';

interface AssignedSiteCardProps {
  assignment: SiteAssignmentDto;
  onRemoveClick: (
    event: React.MouseEvent<HTMLButtonElement>,
    siteId: number
  ) => void;
  isRemoving?: boolean;
  canManage: boolean;
}

export const AssignedSiteCard: React.FC<AssignedSiteCardProps> = ({
  assignment,
  onRemoveClick,
  isRemoving = false,
  canManage,
}) => {
  const handleRemoveClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    if (!isRemoving) {
      onRemoveClick(event, assignment.siteId);
    }
  };

  return (
    <div
      className={`relative border-b border-border-default py-2.5 transition-opacity duration-200 last:border-b-0 ${
        isRemoving ? 'opacity-50' : 'opacity-100'
      }`}
      data-testid="assigned-site-card"
    >
      <div className="flex items-center gap-4">
        <div className="min-w-0 grow">
          <span
            className="type-body-md block truncate font-medium"
            data-testid="site-name"
          >
            {assignment.siteName}
          </span>
          {assignment.what3WordsAddress && (
            <What3WordsLink
              address={assignment.what3WordsAddress}
              variant="caption"
              testId="site-w3w-address"
            />
          )}
        </div>
        {canManage && (
          <Button
            variant="ghost"
            size="sm"
            onClick={handleRemoveClick}
            disabled={isRemoving}
            aria-label={`Remove ${assignment.siteName}`}
            data-testid="remove-site-button"
            className="text-content-error"
          >
            {isRemoving ? 'Removing...' : 'Remove'}
          </Button>
        )}
      </div>
    </div>
  );
};
